{
  "TeamsAuth_UserIntro": "Hi **{}**,",
  "TeamsAuth_UserIntro_2": "Akixi for MS Teams is requesting access to your Microsoft Entra Tenant",
  "TeamsAuth_AdminConsent": "Grant Admin Consent",
  "TeamsAuth_Authorise": "Authorize",
  "TeamsAuth_ConsentedMessage": "Admin Consent granted, please click Authorize to continue",
  "TeamsAuth_AuthorisedMessage": "Authorization granted",
  "TeamsAuth_Decline": "Decline",
  "TeamsAuth_Error_Unknown": "An unrecognised error has occurred. Please try again. If the problem persists, please contact your system administrator.",
  "NAME": "TeamsAuth"
}